export interface IDataTableIpercEquipo {
  equipoId: string;
  nombre: string;
  nombreProceso: string;
  fechaCreado: string;
}
export interface ITableIpercEquipo {
  skip: number;
  take: number;
  search?: string | null;
}

export const InitialTableIpercEquipo: ITableIpercEquipo = {
  skip: 0,
  take: 50,
  search: "",
};

export interface IActualizarEquipoIperc {
  EquipoId: string;
  Nombre: string;
}

export interface IPostCrearEquipoIperc {
  nombre: string;
  procesoId: string;
}

export interface IFilterproceso {
  search: string | null;
}